const FILTERED_VERSION = true;
class Config {
  constructor() {
    if (FILTERED_VERSION) {
      this.getTypography = "getTypographyFiltered/";
      this.getChoicesTotal = "getChoicesTotalFiltered/";
    } else {
      this.getTypography = "getTypography/";
      this.getChoicesTotal = "getChoicesTotal/";
    }
  }

  set language(lang) {
    this.lang = lang;
  }

  get language() {
    return this.lang;
  }

  set dictionary(dictionary) {
    this._dictionary = dictionary;
  }

  get dictionary() {
    return this._dictionary;
  }
}

export default new Config();
